import { IUniConfig } from "../../../uni-base/uni-base-module"
import { $uniUP } from "../.."
import angular from "angular"
import { IDialogForm } from "./dialog-form-factory"

export interface DialogScope extends ng.IScope {
  form: IDialogForm
  modalSize: string
  title: string
  onClose: () => void
  onOpen: () => void
  beforeOpen: () => void
}

$uniUP.directive(
  "dialogForm",
  (
    $http: ng.IHttpService,
    $timeout: ng.ITimeoutService,
    $log: ng.ILogService,
    UniConfig: IUniConfig
  ) => ({
    template: require("./dialog-form.inline.html"),
    restrict: "E",
    scope: {
      form: "<",
      modalSize: "@?",
      title: "@?",
      onClose: "&",
      onOpen: "&",
      beforeOpen: "&"
    },
    // controllerAs : 'gestionCtrl',
    // templateUrl : baseUrl + '/app/templates/vigilancia/progTrabajadoresModal.html',
    transclude: true,
    link: ($scope: DialogScope, element: JQLite, attrs, ctrls) => {
      $log.debug("Instanciando dialogForm", $scope)

      // el primero de los modales solo
      var $modal: any = $(angular.element(element.find(".modal")[0]))

      $scope.modalSize = attrs.modalSize || "modal-lg"

      $log.info($log)

      $modal.on("hide.bs.modal", ($event: Event) => {
        $log.debug("hide.bs.modal")
      })

      $modal.on("hidden.bs.modal", ($event: Event) => {
        $log.debug("Cerrando modal")
        $scope.form.activo = false
        $scope.$apply()

        // informar al controller
        $scope.onClose()

        // solo para el primero
        $event.stopPropagation()
      })

      $scope.$watch(
        () => {
          return $scope.form.activo
        },
        activo => {
          // $log.debug("Cambio visible ", val);

          if (!$scope.form)
            // no inicializado
            return

          $scope.title = $scope.form.title

          if (activo) {
            $log.debug("before open modal")
            $scope.beforeOpen()

            $modal.modal("show")

            $scope.onOpen()
          } else $modal.modal("hide")
        },
        true
      )
    }
  })
)

/** orig unitec 20190506

export class DialogForm implements ng.IDirective {
  templateUrl: string
  restrict = "E"
  scope = {
    form: "<",
    modalSize: "@?",
    title: "@?",
    onClose: "&",
    onOpen: "&",
    beforeOpen: "&"
  }
  // controllerAs : 'gestionCtrl',
  // templateUrl : baseUrl + '/app/templates/vigilancia/progTrabajadoresModal.html',
  transclude = true

  constructor(
    private $http: ng.IHttpService,
    private $timeout: ng.ITimeoutService,
    private $log: ng.ILogService,
    UniConfig: uniBase.IUniConfig
  ) {
    this.templateUrl = UniConfig.baseUrl + "/templates/dialog-form.html"
  }

  link($scope: DialogScope, element: JQLite, attrs, ctrls) {
    this.$log.debug("Instanciando dialogForm", $scope)

    // el primero de los modales solo
    var $modal: any = $(angular.element(element.find(".modal")[0]))

    $scope.modalSize = attrs.modalSize || "modal-lg"

    this.$log.info(this.$log)

    $modal.on("hide.bs.modal", $event => {
      this.$log.debug("hide.bs.modal")
    })

    $modal.on("hidden.bs.modal", $event => {
      this.$log.debug("Cerrando modal")
      $scope.form.activo = false
      $scope.$apply()

      // informar al controller
      $scope.onClose()

      // solo para el primero
      $event.stopPropagation()
    })

    $scope.$watch(
      () => {
        return $scope.form.activo
      },
      activo => {
        // this.$log.debug("Cambio visible ", val);

        if (!$scope.form)
          // no inicializado
          return

        $scope.title = $scope.form.title

        if (activo) {
          this.$log.debug("before open modal")
          $scope.beforeOpen()

          $modal.modal("show")

          $scope.onOpen()
        } else $modal.modal("hide")
      },
      true
    )
  }
}
*/
